<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.invite.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="my-code">
          <div>
            <b>{{ $t('modals.invite.linkSendTxt') }}</b>
          </div>
          <div class="detail">
            <b-input :value="hostname" class="input-url" readonly> </b-input>
            <div
              class="copy"
              v-clipboard:copy="hostname"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <i class="fas fa-copy"></i><br />{{ $t('modals.invite.copyTxt') }}
            </div>
          </div>
        </div>
        <b-table
          v-if="userInvite.length > 0"
          class="m-t-20"
          :data="userInvite"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page="current"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :range-before="3"
          :range-after="1"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <b-table-column
            field="name"
            :label="$t('modals.invite.fromLabel')"
            v-slot="props"
          >
            {{ props.row.from.name }}
          </b-table-column>
          <b-table-column
            field="amount"
            :label="$t('modals.invite.amountLabel')"
            numeric
            v-slot="props"
          >
            {{ props.row.amount }}
          </b-table-column>
          <b-table-column
            field="date"
            :label="$t('modals.invite.createdAtLabel')"
            v-slot="props"
          >
            {{ props.row.createdAt | datetimeFormat }}
          </b-table-column>
        </b-table>
      </section>
    </div>
  </div>
</template>

<script>
import apiInvite from '@/api/invite'

export default {
  name: 'ModalInvite',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      hostname: `${location.protocol}//${location.host}/register?code=PR${this.profile._id}`,
      userInvite: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      current: 1,
      perPage: 10
    }
  },
  mounted() {
    this.getInvite()
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    async getInvite() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiInvite.getInvite(this.current, this.perPage)
          this.userInvite = data.invites

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    onCopy(e) {
      this.$buefy.toast.open({
        message: `copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .my-code {
  width: 100%;
  // text-align: center;

  .detail {
    display: flex;
    justify-content: space-between;
  }
  .input-url {
    width: 80%;

    input {
      padding-left: 10px !important;
      font-size: 14px;
    }
  }
  .copy {
    margin-left: 10px;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
